import classNames from 'classnames';
import type { MouseEventHandler } from 'react';
import * as styles from '../Pricing.css';

interface Props {
  isSelected: boolean;
  label: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const Tab = ({ isSelected, label, onClick }: Props) => (
  <button
    type="button"
    className={classNames(
      'text-xs w-full text-center h-full relative capitalize px-4 py-1 whitespace-nowrap',
      styles.tierTabBorder,
      isSelected && 'shadow-sm',
      isSelected ? styles.tierTabSelectedTextColor : styles.tierTabTextColor,
      isSelected && styles.tierTabSelectedBackgroundColor,
    )}
    onClick={onClick}
  >
    {label}
  </button>
);
